import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@utils/seo";
import i18n from "@modules/shared/localization/i18n";
import { pageQueryOptions } from "@modules/shopify/hooks";
import { InfoPageBody } from "@modules/shop/components/InfoPage/InfoPageBody";
import { getCountryVariables } from "@/modules/shared/localization/const/countries";

export const Route = createFileRoute(
  "/$locale/_layout/(public)/_public/info/payment-options"
)({
  component: PaymentOptionsPage,
  ssr: true,
  loader: async ({ context: { queryClient }, params }) => {
    const localeVars = getCountryVariables(params.locale);
    return queryClient.ensureQueryData(
      pageQueryOptions({ handle: "payment-options", ...localeVars })
    );
  },
  staleTime: 60_000 * 60, // 1 hour
  headers: () => ({
    "Cache-Control":
      "public, max-age=3600, s-maxage=3600, stale-while-revalidate=86400",
  }),
  head: ({ params, loaderData }) => {
    const t = i18n.getFixedT(params.locale);
    const page = loaderData?.page;
    return {
      meta: [
        ...seo({
          title: page?.seo?.title || t("Seo:paymentOptions.title"),
          description:
            page?.seo?.description || t("Seo:paymentOptions.description"),
        }),
      ],
    };
  },
});

function PaymentOptionsPage() {
  const { locale } = Route.useParams();
  return <InfoPageBody handle="payment-options" locale={locale} />;
}
